import { Button, Stack, styled } from '@ltvco/refresh-lib/theme';

import { ChatPageContainerStack } from 'components/DeepSearch/components/components';
import { transparentScrollbar } from 'components/DeepSearch/styleMixins';

export const PageContainer = styled(ChatPageContainerStack)({
  width: '100%',
  height: '100%',
  overflowY: 'hidden',
});

export const MonitoredReportsList = styled(Stack)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  marginTop: theme.spacing(2),
  overflowY: 'auto',
  ...transparentScrollbar,
}));

export const PaginationButton = styled(Button)({
  minWidth: 36,
});

export const UpdatesButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 600,
  color: theme.palette.primary.main,
}));

export const ViewButton = styled(Button)({
  textTransform: 'none',
  fontWeight: 600,
});
